const requireComponent = require.context("./comp", false, /\w+.(vue|js)$/);

const cmps = {};
//排除
const filterCmps = [];

requireComponent.keys().forEach((fileName) => {
  const cmp = requireComponent(fileName).default;
  !filterCmps.includes(fileName) && (cmps[cmp.name] = cmp);
});
// console.log(cmps)
export default cmps;
